<div class="section-header">
    <h4 class="section-header__title">{{ title }}</h4>
    <ng-container *ngFor="let description of descriptions">
        <p class="section-header__description">{{ description }}</p>
    </ng-container>
    <hr class="section-header__line" />
</div>